import { render, staticRenderFns } from "./MKasaPromoItems.vue?vue&type=template&id=3d6affd5"
import script from "./MKasaPromoItems.vue?vue&type=script&lang=js"
export * from "./MKasaPromoItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports